import styled from '@emotion/styled'

export const Text = styled.p(() => ({
  margin: '8px 0 0 24px',

  fontSize: '14px',
  color: '#595959',
  lineHeight: '18px'
}))
